import * as React from "react";
import { SVGProps } from "react";

const DistrictzeroX = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91 95" {...props}>
    <defs>
      <style>{".cls-3{fill:#2c398f}"}</style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          fill="#04ffcc"
          d="M91.39 38.67a29.87 29.87 0 0 0-3.4-8.9c-3.3-5.5-10.5-13.5-19.5-19.8 0 0-6.8-4.4-10-5.9-11.7-5.4-24.8-6.5-36 3.4-18.8 16.7-28.2 40-18.8 63.2.2.5 5.4 14.7 36.6 24.2 13.7.4 21.7-.4 30.5-5.5 11.5-6.6 18.2-18.6 20.6-30.8.7-3.7.8-16.2 0-19.9"
        />
        <path
          fill="#7df8fb"
          d="M55 5.77v22.3l-25.8-1.6-10.6 13.4-1.3 25.3 8.8 9.4 13.2 6.6 17.3 1.9 18.8-4.8v-46.5l-3.6-19.3s-10.1-7.9-16.7-9.8"
        />
        <path
          d="M85.19 61.07c-3.6-.2-1.6-5.9-3.2-12.4-1.9-7.2.9-12.2 4.6-12a11 11 0 0 1 4.8 2 29.87 29.87 0 0 0-3.4-8.9c-3.3-5.5-10.5-13.5-19.5-19.8v60.3a6.09 6.09 0 0 1-11.6 2.6 23.73 23.73 0 1 1-.6-40.7V8.77a5.88 5.88 0 0 1 2.2-4.7c-11.7-5.4-24.8-6.5-36 3.4-18.8 16.7-28.2 40-18.8 63.2.2.5.4 1 .6 1.4a5.06 5.06 0 0 1 1.1-1.5c4.9-5 10.3 5.2 21.8 11.1 7.3 3.7 11.5 8.6 13.1 13.2 10.7 1.3 21.7-.4 30.5-5.5 11.5-6.6 18.2-18.6 20.6-30.8a10.16 10.16 0 0 1-6.2 2.5ZM46 13.67c2.7-.1 5.2 3.1 5.3 4.6s-2.3.9-4.9 1.8c-2.9 1-5 .1-5.1-1.4s1.89-4.9 4.7-5Z"
          className="cls-3"
        />
        <path
          d="M40.09 61.47c5.8 3.3 12.8 2 14.1-5.4.7-4.3.3-11-3.5-13.1-12.6-7.2-23.2 11.3-10.6 18.5"
          className="cls-3"
        />
      </g>
    </g>
  </svg>
);

export default DistrictzeroX;
